import {
  FilterQuery,
  ParameterAndFilter,
  ParameterFilter,
  ParameterOrFilter,
  ParameterRangeFilter,
} from "../../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";

export const applyParameterFilter = (
  newlyAppliedFilter: ParameterFilter | null,
  parameterId: number,
  currentFilter: FilterQuery["parameters"] | undefined
): FilterQuery["parameters"] => {
  if (newlyAppliedFilter === null) {
    const filterCopy = { ...currentFilter };
    delete (filterCopy as any)[parameterId];
    return filterCopy;
  } else {
    return { ...currentFilter, [parameterId]: newlyAppliedFilter };
  }
};

export const makeRangeFilter = (
  from: number,
  to: number
): ParameterRangeFilter => ({
  type: "range",
  range: {
    gte: from,
    lte: to,
  },
});

const filterUnique = <T>(array: T[]): T[] =>
  array.filter((value, index, array) => array.indexOf(value) === index);

export const makeAndFilter = (
  currentFilter: ParameterAndFilter | undefined,
  valuedId: number,
  append: boolean
): ParameterAndFilter | null => {
  const valueIds = changeSelectValueIds(currentFilter, valuedId, append);
  if (valueIds.length > 0) {
    return {
      type: "and",
      valueIds,
    };
  } else {
    return null;
  }
};

export const makeOrFilter = (
  currentFilter: ParameterOrFilter | undefined,
  valuedId: number,
  append: boolean
): ParameterOrFilter | null => {
  const valueIds = changeSelectValueIds(currentFilter, valuedId, append);
  if (valueIds.length > 0) {
    return {
      type: "or",
      valueIds,
    };
  } else {
    return null;
  }
};

export const changeSelectValueIds = (
  currentFilter: ParameterAndFilter | ParameterOrFilter | undefined,
  valuedId: number,
  append: boolean
): number[] => {
  if (append) {
    return filterUnique([...(currentFilter?.valueIds ?? []), valuedId]);
  } else {
    return (currentFilter?.valueIds ?? []).filter((id) => id !== valuedId);
  }
};
